import { useEffect, useRef } from 'react'
import { subscribeToScroll } from '@/lib/scroll-store'

export function ScrollProgress() {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(
    () =>
      subscribeToScroll(({ progress }) => {
        const element = ref.current
        if (element !== null) element.style.transform = `scaleX(${progress.toFixed(5)})`
      }),
    [],
  )

  return (
    <div className="scroll-progress" aria-hidden="true">
      <div className="scroll-progress__bar" ref={ref} />
    </div>
  )
}
